import { Star, Quote } from "lucide-react";
import { FadeIn } from "@/components/site/FadeIn";
import { TESTIMONIALS } from "@/data/book";

export const ReaderReviews = () => (
  <section
    id="praise"
    data-testid="reviews-section"
    className="relative py-28 sm:py-32 bg-[#fdfbf7]"
  >
    <div className="max-w-6xl mx-auto px-6">
      <FadeIn className="text-center max-w-2xl mx-auto mb-16">
        <p className="text-xs uppercase tracking-[0.28em] text-[#2a7b76] font-semibold mb-4">
          Early praise
        </p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#201c19] font-light leading-tight">
          What early readers are feeling
        </h2>
      </FadeIn>

      <div className="grid md:grid-cols-3 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <FadeIn
            key={t.quote}
            delay={i * 0.08}
            data-testid={`review-card-${i + 1}`}
            className="relative rounded-2xl border border-stone-200/80 bg-white p-8 shadow-[0_4px_24px_rgba(32,28,25,0.04)] flex flex-col"
          >
            <Quote size={28} className="text-[#c07a67]/40 mb-4" />
            <div data-testid={i === 0 ? "review-star-rating" : undefined} className="flex gap-1 mb-5">
              {Array.from({ length: 5 }).map((_, s) => (
                <Star key={s} size={15} className="fill-[#c2751f] text-[#c2751f]" />
              ))}
            </div>
            <p className="font-display text-xl leading-relaxed text-[#201c19] italic flex-1">
              "{t.quote}"
            </p>
            <div className="mt-6 pt-5 border-t border-stone-100">
              <p className="text-sm font-semibold text-[#201c19]">{t.name}</p>
            </div>
          </FadeIn>
        ))}
      </div>
    </div>
  </section>
);

export default ReaderReviews;
